import {DialogFooter, DialogHeader, DialogHeading} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledProjectPlannedAccessesEditDialog = styled.div`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
    grid-template-columns: 1fr;
`

export const StyledProjectPlannedAccessesEditDialogHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
        align-items: flex-start;
        padding: ${spacing * 4}px ${spacing * 6}px;
    `
)

export const StyledProjectPlannedAccessesEditDialogHeading = styled(DialogHeading)(
    ({theme: {typography, palette}}) => css`
        ${typography.textLg};
        font-weight: 500;
        color: ${palette.neutral['950']};
    `
)

export const StyledProjectPlannedAccessesEditDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        gap: ${spacing * 2}px;
        justify-content: flex-end;
    `
)
